/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Not_In_EffectInputs */

const en_us2_plan_not_in_effect = /** @type {(inputs: Plan_Not_In_EffectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That plan is no longer the one in effect. Refresh the screen.`)
};

const pt_br2_plan_not_in_effect = /** @type {(inputs: Plan_Not_In_EffectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse plano não é mais o que está em vigor. Atualize a tela.`)
};

const es_419_plan_not_in_effect = /** @type {(inputs: Plan_Not_In_EffectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ese plan ya no es el que está vigente. Actualiza la pantalla.`)
};

const pt_pt2_plan_not_in_effect = /** @type {(inputs: Plan_Not_In_EffectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse plano já não é o que está em vigor. Atualiza o ecrã.`)
};

const fr_fr2_plan_not_in_effect = /** @type {(inputs: Plan_Not_In_EffectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce programme n'est plus celui en vigueur. Actualise l'écran.`)
};

const de_de2_plan_not_in_effect = /** @type {(inputs: Plan_Not_In_EffectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Plan ist nicht mehr der aktive. Aktualisiere den Bildschirm.`)
};

const it_it2_plan_not_in_effect = /** @type {(inputs: Plan_Not_In_EffectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quella scheda non è più quella in vigore. Aggiorna la schermata.`)
};

/**
* | output |
* | --- |
* | "That plan is no longer the one in effect. Refresh the screen." |
*
* @param {Plan_Not_In_EffectInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_not_in_effect = /** @type {((inputs?: Plan_Not_In_EffectInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Not_In_EffectInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_not_in_effect(inputs)
	if (locale === "es-419") return es_419_plan_not_in_effect(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_not_in_effect(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_not_in_effect(inputs)
	if (locale === "de-DE") return de_de2_plan_not_in_effect(inputs)
	if (locale === "it-IT") return it_it2_plan_not_in_effect(inputs)
	return en_us2_plan_not_in_effect(inputs)
});
export { plan_not_in_effect as "plan.not_in_effect" }